
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocationItemsGrid extends Serenity.EntityGrid<StockAllocationItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.StockAllocationItems'; }
        protected getDialogType() { return StockAllocationItemsDialog; }
        protected getIdProperty() { return StockAllocationItemsRow.idProperty; }
        protected getInsertPermission() { return StockAllocationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return StockAllocationItemsRow.localTextPrefix; }
        protected getService() { return StockAllocationItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        //protected getSlickOptions() {
        //    let opt = super.getSlickOptions();
        //    opt.editable = true;
        //    opt.autoEdit = true;
        //    //opt.forceFitColumns = true;
        //    return opt;
        //}
        
    }
}